import { useMutation, useQuery } from '@tanstack/react-query';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import {
  AppointmentReqBody,
  AppointmentRequest,
} from '../../../types/appointmentRequests';
import { AcademiaResponse } from '../../../types/common';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const useAppointmentRequestActions = (
  whichAction: 'appointmentReqList' | '',
  appId?: number
) => {
  // query function to fetch all the appointment requests from database declared here
  const getAppointmentReqList = useQuery({
    queryKey: ['appointment-request-list'],
    queryFn: async (): Promise<AcademiaResponse<Array<AppointmentRequest>>> => {
      const response = await getPrivateAxiosInstance('appointment').get(
        '/appointment/request/list/'
      );

      return response.data;
    },

    ...returnQueryConfig(whichAction === 'appointmentReqList'),
  });

  // query function to fetch specific appointment
  const getAppointmentReqById = useQuery({
    queryKey: ['appointment-request-by-id', appId],
    queryFn: async (): Promise<AcademiaResponse<AppointmentRequest>> => {
      const response = await getPrivateAxiosInstance('appointment').get(
        `/appointment/request/${appId}/`
      );

      return response.data;
    },

    ...returnQueryConfig(!!appId),
  });

  const createNewAppointmentRequest = useMutation({
    mutationFn: async ({
      body,
    }: {
      body: AppointmentReqBody;
    }): Promise<AcademiaResponse<AppointmentRequest>> => {
      const response = await getPrivateAxiosInstance('appointment').post(
        '/appointment/request/create/',
        body
      );

      return response.data;
    },
  });

  return {
    getAppointmentReqList,
    getAppointmentReqById,
    createNewAppointmentRequest,
  };
};

export default useAppointmentRequestActions;
